<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                level: '100',
                status: 'activated',
            }"
            :filters-default="{
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'level',
                    title: '権限',
                    options: [
                        { text: '全て', value: '' },
                        { text: 'おみそ', value: '000' },
                        { text: '利用者', value: '100' },
                        { text: '管理者', value: '200' },
                        { text: '開発者', value: '300' },
                    ],
                },
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '仮登録', value: 'pending' },
                        { text: '登録済', value: 'activated' },
                        { text: '停止中', value: 'suspended' },
                    ],
                },
            ]"
            filters-q-placeholder="名前"
            form-modal-id="user"
            search-action="user/index"
            row-class="flex-nowrap mx-0 my--2"
            >
            <template v-slot:form="{ form, init }">
                <User :model="form" :init="init" @save="$refs.gridPage.save" @destroy="$refs.gridPage.destroy"></User>
            </template>

            <template v-slot:column="{ item }">
                <div class="d-flex w-100">
                    <div class="align-self-center flex-shrink-1">
                        <b-form-checkbox
                            v-model="item.checked"
                            :value="true"
                            :unchecked-value="false"
                            >
                        </b-form-checkbox>
                    </div>
                    <div class="flex-grow-1">
                        <div class="d-flex flex-nowrap bd-highlight">
                            <div class="p-2 flex-grow-1 bd-highlight d-flex">
                                <b-row class="no-gutters w-100">
                                    <b-col sm="12" class="align-self-center">
                                        <UserBadges :model="item" class="mb-1" />
                                        <p class="mb-1 font-weight-bold">
                                            {{ item.email }}
                                        </p>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import User from '@/components/User.vue'
import UserBadges from '@/components/UserBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import FormDate from '@/components/FormDate.vue'
import ItemInfo from '@/components/ItemInfo.vue'

export default {
    components: {
        GridPage,
        User,
        UserBadges,
        ItemThumb,
        FormDate,
        ItemInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        async listUser(item, provider) {
console.log(item)
            await this.$store
                .dispatch('user/list', { uuid: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
    },
}
</script>

